import Axios from 'axios';

const Api = Axios.create({
    baseURL: umano_theme.rootapiurl,
    headers: {
        'content-type': 'application/json',
        'X-WP-Nonce': umano_theme.nonce
    }
});
export default Api;
